<template>
    <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obModal.titulo"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="$root.isTouch" rounded outlined @click="close(false)">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Póliza" color="textbox" readonly :value="obModal.poliza" outlined
                                    dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Aseguradora" color="textbox" readonly :value="obModal.aseguradora"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Contratante" color="textbox" readonly :value="obModal.contratante"
                                    outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Inicio" prepend-inner-icon="event"  color="textbox" readonly :value="obModal.fechaDesde"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Fin" prepend-inner-icon="event" color="textbox" readonly :value="obModal.fechaHasta"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Ocurrencia" prepend-inner-icon="event"  color="textbox" readonly
                                    :value="obModal.fechaOcurrencia" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Asegurado" color="textbox" readonly :value="obModal.asegurado"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Tipo Siniestro" color="textbox" readonly
                                    :value="obModal.tipoSiniestro" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field color="textbox" v-model="obModal.fechaOcurrencia"
                                    label="Fecha Cierre Apertura *" :rules="requeridoRegla"
                                    prepend-inner-icon="event" readonly outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" :sm="show ? 3 : 4">
                                <v-autocomplete label="Estado Siniestro *" color="textbox"
                                    v-model="obModal.idEstadoSiniestro" :items="listGeneral.listEstadoSiniestro"
                                    item-text="estadoSiniestro" item-value="idEstadoSiniestro" :rules="requeridoRegla"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" :sm="show ? 3 : 4">
                                <v-text-field label="N° de Reclamo *" color="textbox" :rules="requeridoRegla"
                                    v-model="obModal.nroReclamo" outlined dense />
                            </v-col>
                            <v-col cols="12" :sm="show ? 3 : 4">
                                <v-text-field label="Valor de Reclamo *" color="textbox" v-model="obModal.valorReclamo"
                                    :rules="_.concat(requeridoRegla,decimal)" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3" v-if="show">
                                <v-dialog ref="dialog" v-model="openDate2" :return-value.sync="obModal.fechaNegacion"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="obModal.fechaNegacion"
                                            label="Fecha de Negación *" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on" />
                                    </template>
                                    <v-date-picker color="primary" v-model="obModal.fechaNegacion" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded @click="openDate2 = false" v-html="'Salir'">
                                        </v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.dialog.save(obModal.fechaNegacion)" v-html="'Guardar Fecha'">
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>

                        <v-row dense v-if="!show">
                            <v-col cols="12" sm="4">
                                <v-text-field label="Valor Pagado *" color="textbox"
                                    :rules="_.concat(requeridoRegla,decimal)" v-model="obModal.valorPagado" outlined
                                    dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Valor Deducible *" color="textbox" :rules="requeridoRegla"
                                    v-model="obModal.valorDeducible" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-dialog ref="dialog2" v-model="openDate" :return-value.sync="obModal.fechaPago"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="obModal.fechaPago"
                                            label="Fecha Pago *" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on" />
                                    </template>
                                    <v-date-picker color="primary" v-model="obModal.fechaPago" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded @click="openDate = false" v-html="'Salir'">
                                        </v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.dialog2.save(obModal.fechaPago)" v-html="'Guardar Fecha'">
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="8">
                                <v-textarea dense label="Observacion *" color="textbox"
                                    v-model.trim="obModal.observacion" :value="obModal.observacion" counter="300"
                                    :rules="_.size(obModal.observacion) > 0 ? _.concat(requeridoRegla,max300Regla) : []" outlined />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-file-input label="Cargar Documento *" @change="loadFile" color="textbox" outlined dense 
                                accept="application/pdf" v-model="obModal.file" :rules="requeridoRegla"></v-file-input>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn outlined dense rounded class="mr-1" @click="close(false)">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="validar(false)" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalLiquidacionSiniestroComponent',
        inject: ['close'],
        props: {
            open: {
                type: Boolean,
                default: false
            },
            listGeneral:{
                type:Object,
                default:{}
            },
            obModal: {
                type: Object,
                default: {}
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            openDate: false,
            openDate2: false,
            disabled: false
        }),
        computed:{
            show(){
                return _.toNumber(this.obModal.idEstadoSiniestro) == _.toNumber(this.parametros.idEstadoSiniestroRechazado) ? true : false;
            }
        },
        methods:{
            loadFile(e){
                try {
                    var file = e;
                    if(_.isUndefined(file)) throw mensajeEstandar.archivo;
                    if(!_.includes(_.get(file,'name',''),'.pdf')) throw  mensajeEstandar.archivo;
    
                        var fr = new FileReader ()
                        fr.readAsDataURL(file)
                        fr.addEventListener('load', () => {
                            this.obModal.base64 = fr.result;
                        })
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            validar(){
                try {
                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                    var error = 'E';
                        this.disabled = true;   
                        var fecha = moment().format('YYYY-MM-DD h:mm:ss');
                        var nro = _.split(this.obModal.polCer,'-');
                        
                        if(!this.show) //Aprobado
                        {
                            var o = {
                                obSiniestro:{
                                    idSiniestro:this.obModal.idSiniestro,
                                    idCertificado:this.obModal.idCertificado,
                                    idPoliza:this.obModal.idPoliza,
                                    nroReclamo:this.obModal.nroReclamo,
                                    fechaRespuesta:fecha,
                                    idEstadoSiniestro:this.obModal.idEstadoSiniestro,
                                    poliza:_.join(nro,'_'),
                                    idEstado:this.obModal.idEstado
                                },
                                obDetalleSiniestro:{
                                    idSecSiniestroDetalle:this.obModal.idSecSiniestroDetalle,
                                    valorReclamo:this.obModal.valorReclamo,
                                    valorPagado:this.obModal.valorPagado,
                                    valorDeducible:this.obModal.valorDeducible,
                                    fechaPago:fecha,
                                    observacion:this.obModal.observacion,
                                    documento:this.obModal.base64,
                                    idEstadoDetalle:this.parametros.idEstadoDefault
                                }                                
                            };
                        }else{//Negado
                                var o = {
                                    obSiniestro:{
                                        idSiniestro:this.obModal.idSiniestro,
                                        idCertificado:this.obModal.idCertificado,
                                        idPoliza:this.obModal.idPoliza,
                                        fechaRespuesta:fecha,
                                        nroReclamo:this.obModal.nroReclamo,
                                        idEstadoSiniestro:this.obModal.idEstadoSiniestro,
                                        poliza:_.join(nro,'_'),
                                        idEstado:this.obModal.idEstado
                                    },
                                    obDetalleSiniestro:{
                                        idSecSiniestroDetalle:this.obModal.idSecSiniestroDetalle,
                                        valorReclamo:this.obModal.valorReclamo,
                                        fechaPago:fecha,
                                        observacion:this.obModal.observacion,
                                        documento:this.obModal.base64,
                                        idEstadoDetalle:this.parametros.idEstadoDefault
                                    }                                
                                };
                        }

                        axios.post(`${BASE_URI}administrador/siniestro/insertOrUpdate/liquidacion`,o)
                             .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    mensajeAlertaTiempo('Registro actualizado con exito.','S');
                                    this.disabled = false;
                                    this.close(true);
                             })
                             .catch((e)=>{
                                mensajesAlerta(e,error);
                                this.disabled = false;
                            });
                } catch (e) {
                    mensajesAlerta(e,'I');
                    this.disabled = false;
                }
            }
        }
    }
</script>